module.exports = __webpack_public_path__ + "static/media/loan-range.8f53acde.svg";